import React from "react";
import useGlobalHook from "use-global-hook";
import * as actions from "../Actions/RoleActions";


const initialState = {
  status: 200,
  isLoading: false,
  message: "",
  header: {},
  data: [],
  dataRole: {},
  usersStatus: [],
  lastPage: false,
  module: []
};

const RoleStore = useGlobalHook(React, initialState, actions);

export default RoleStore;
